import axios from 'axios'

let _axiosBackendApi = null;

export function initAxiosBackend(config = {}) {
    _axiosBackendApi = axios.create({
        baseURL: config.baseURLApi,
        headers: {
            'accept': 'application/json',
        }
    })
}

export function  getAxiosBackendApi() {
    return _axiosBackendApi
}
